import React from 'react'
import styles from './UIGamePlayerInformationAvatar.module.scss'
import {VictoryPointStateReader} from '@colonist/game-base-types'
import {type PlayerValidator} from '@colonist/game-mechanic-validators'
import {type PlayerState} from '@colonist/game-states'
import {type TranslationObject} from '@colonist/i18n'
import {Avatar} from '../../../../common/Avatar/index.ts'
import {VictoryPointCountBanner} from '../../../../common/VictoryPointCountBanner/VictoryPointCountBanner.tsx'
import {UIGamePlayerOptionsDropdown} from '../../../../common/UIGamePlayerOptionsDropdown/index.ts'
import clsx from 'clsx'

/**
 * @deprecated Use usePlayerVictoryPoints instead
 */
const getVictoryPointsText = (playerState: PlayerState, isCurrentUser: boolean): TranslationObject => {
    const publicVictoryPoints = VictoryPointStateReader.totalPublicVictoryPoints(playerState.victoryPointsState)
    const privateVictoryPoints = VictoryPointStateReader.totalPrivateVictoryPoints(playerState.victoryPointsState)
    const doesPlayerHaveHiddenVictoryPoints = publicVictoryPoints !== privateVictoryPoints && privateVictoryPoints !== 0 && isCurrentUser
    return {
        key: 'strings:game.playerInformation.victoryPoint.display',
        options: {
            publicVictoryPoints: publicVictoryPoints,
            privateVictoryPoints: privateVictoryPoints,
            context: doesPlayerHaveHiddenVictoryPoints ? 'private' : '',
        },
    }
}

export interface UIGamePlayerInformationUserProps {
    victoryPointsToWin: number
    playerValidator: PlayerValidator
    isCurrentUser: boolean
    className?: string
}

export const UIGamePlayerInformationAvatar = ({
    victoryPointsToWin,
    playerValidator,
    isCurrentUser,
    className,
}: UIGamePlayerInformationUserProps) => {
    const victoryPointsText = getVictoryPointsText(playerValidator.state, isCurrentUser)

    return (
        <div className={clsx(styles.avatarAndPoints, className, {
            [styles.currentUser]: isCurrentUser,
        })}>
            <UIGamePlayerOptionsDropdown className={styles.avatarWrapper} playerValidator={playerValidator}>
                <Avatar
                    className={styles.avatar}
                    color={playerValidator.color}
                    image={playerValidator.displayIcon}
                    profilePictureUrl={playerValidator.profilePictureUrl}
                />
            </UIGamePlayerOptionsDropdown>
            <VictoryPointCountBanner
                className={styles.victoryPointsContainer}
                victoryPointsText={victoryPointsText}
                victoryPointsToWin={victoryPointsToWin}
                isLargeRibbon={isCurrentUser}
            />
        </div>
    )
}
